
<template>
  <div>
    <div id="testAudio">
      <audio :src="src" id="audio" ref="audio"></audio>
      <div class="shoot">
        <span v-if="showshootTip"
          >您上次观看{{ shootTime | formatSeconds }}，已为您自动续播</span
        >
      </div>
      <div class="cont">
        <span>{{ currentTime | formatSeconds }}</span>
        <div class="scheduleslider">
          <van-slider
            v-model="currentTimeLength"
            @change="onChange"
            @drag-start="onChangeStart"
            @drag-end="onChangeEnd"
            bar-height="4px"
            active-color="linear-gradient(81deg, #B6D3FF 0%, #4E7DF7 100%)"
            inactive-color="rgba(225,225,225,.2)"
          >
            <template #button>
              <div class="custom-button"></div>
            </template>
          </van-slider>
        </div>
        <span>{{ duration | formatSeconds }}</span>
      </div>
      <div class="mune">
        <img src="./../../../assets/school/fast.png" @click="fast()" />
        <img
          src="./../../../assets/school/audioplay.png"
          v-if="!isPlay"
          @click="play()"
        />
        <img
          src="./../../../assets/school/audiopause.png"
          v-else
          @click="paused()"
        />
        <img src="./../../../assets/school/speed.png" @click="speed()" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    id: {
      default: 0,
    },
    // 是否加入学习中心
    isAddStudyCenter: {
      type: Boolean,
      default: false,
    },
    //续播时间
    shootTime: {
      default: 0,
    },
    //试看时间
    trySeeTime: {
      default: 0,
    },
  },
  data() {
    return {
      isPlay: false, //是否播放中
      isPlayEnd: false, //是否播放结束
      duration: 0, //总时长
      currentTime: 0, //当前时常
      currentTimeLength: 0, //已播放进度条长度
      // shootTime: 20, //续播时间
      // trySeeTime:60,//试看时间
      showshootTip: false, //是否显示续播提示
      Media: {}, //video
    };
  },
  filters: {
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result =
        "" +
        (parseInt(secondTime) < 10
          ? "0" + parseInt(secondTime)
          : parseInt(secondTime));

      // if (minuteTime > 0) {
      result =
        "" +
        (parseInt(minuteTime) < 10
          ? "0" + parseInt(minuteTime)
          : parseInt(minuteTime)) +
        ":" +
        result;
      // }
      // if (hourTime > 0) {
      result =
        "" +
        (parseInt(hourTime) < 10
          ? "0" + parseInt(hourTime)
          : parseInt(hourTime)) +
        ":" +
        result;
      // }
      return result;
    },
  },
  mounted() {
    let that = this;
    // this.isPlayEnd = false;
    this.Media = document.getElementById("audio");
    // 视频初次加载
    this.Media.onloadeddata = (e) => {
      that.duration = parseInt(e.target.duration);
      if (that.shootTime) {
        that.Media.currentTime = that.shootTime;
        if (that.shootTime > 0) {
          that.showshootTip = true;
          setTimeout(() => {
            that.showshootTip = false;
          }, 6000);
        }
      }
    };
    // 播放持续触发
    this.Media.ontimeupdate = (e) => {
      that.currentTime = parseInt(e.target.currentTime);
      that.currentTimeLength = (that.currentTime / that.duration) * 100;
      // 试看结束
      if (that.trySeeTime > 0 && !that.isAddStudyCenter) {
        if (that.currentTime >= that.trySeeTime) {
          that.$emit("trySeeEnd", that);
          that.paused();
        }
      }
    };
    // 视频暂停
    this.Media.onpause = (e) => {
      that.isPlay = false;
      that.$emit("suspend", that);
      // 视频暂停并且加入学习中心，保存学习进度
      if (that.isAddStudyCenter || that.trySeeTime == 0) {
        that.updateProcess();
      }
    };
    this.Media.onplaying = (e) => {
      that.isPlay = true;
      that.$emit("play", that);
    };
    // 播放结束
    this.Media.onended = (e) => {
      that.isPlayEnd = true;
      that.isPlay = false;
      that.$emit("playEnd", that);
    };
    // 视频播放错误
    this.Media.onerror = (e) => {
      // 进行容错处理
    };
  },
  methods: {
    // 重新加载路径
    reloadSrc(url) {
      this.paused();
      this.$refs.audio.src = url;
      this.$refs.audio.load();
    },
    // 开始播放
    play() {
      this.Media.play();
      this.isPlay = true;
      if (this.isPlayEnd) {
        this.isPlayEnd = false;
      }
    },
    // 暂停
    paused() {
      this.Media.pause();
      this.isPlay = false;
    },
    // 拖动快进快退
    onChange(value) {
      this.Media.currentTime = (this.duration * value) / 100;
    },
    onChangeStart() {
      this.paused();
    },
    onChangeEnd() {
      this.play();
    },
    // 后退
    fast() {
      if (this.Media.currentTime - 10 <= 0) {
        this.Media.currentTime = 0;
      } else {
        this.Media.currentTime = this.Media.currentTime - 10;
      }
    },
    // 前进
    speed() {
      if (this.Media.currentTime + 10 >= this.duration) {
        this.Media.currentTime = this.duration;
      } else {
        this.Media.currentTime = this.Media.currentTime + 10;
      }
    },
    // 加入学习
    joinStudy() {
      this.$emit("joinStudy");
    },
    // 记录进度
    updateProcess() {
      this.$api
        .post("school/member/update/learning/process", {
          courses_id: this.id, //类型：Number  必有字段  备注：课程id
          total_length: this.duration, //类型：Number  必有字段  备注：视频、音频、图文总长度
          breakpoint: this.currentTime, //类型：Number  必有字段  备注：视频、音频、图文播放断点
        })
        .then((res) => {
          // console.log('保存进度成功')
        });
    },
  },
};
</script>

<style scoped>
#testAudio {
  width: 100%;
}
#testAudio > .shoot {
  margin: 0 auto;
  height: 15px;
  text-align: center;
  font-size: 12px;
  width: 240px;
  border-radius: 13px;
}
#testAudio > .shoot span {
  background-color: rgba(0, 0, 0, 0.6);
  display: block;
  margin: 0;
  border-radius: 13px;
}
#testAudio .cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
#testAudio .cont span {
  margin: 0;
}
#testAudio .scheduleslider {
  flex: 1;
  margin: 0 12px;
}
#testAudio .custom-button {
  width: 8px;
  height: 14px;
  background: linear-gradient(180deg, #86b4fc 0%, #4e7df7 100%);
  border-radius: 6px;
}
#testAudio .mune {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 182px;
  margin: 15px auto 0;
}
#testAudio .mune img {
  width: 24px;
  height: 24px;
  margin: 0;
}
#testAudio .mune img:nth-child(2) {
  width: 52px;
  height: 36px;
}
</style>